import axios from 'utils/axios';
import { Form, Select, Tag } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import configFile from 'config.json';
import { NotificationManager } from 'react-notifications';

const TAG_API_BASE = `${configFile.PROD_SERVER_URL}/tag`;

const SelectStoreTags = ({
    name,
    form,
    required,
    ...props
}) => {
    const [tags, setTags] = useState([])
    const storeName = form.getFieldValue('storeName')
    const colorByValue = useMemo(
        () => new Map(tags.map(o => [o.slug, o.color])),
        [tags]
    );
    const fetchTags = async () => {
        try {
            if (props.tags?.length > 0) {
                setTags(props.tags)
            } else {
                const { data: result } = await axios.post(`${TAG_API_BASE}/getAllTags`)
                setTags(result.data)
            }
        } catch (err) {
            NotificationManager.error(
                err?.response?.data?.errorMessage || 'Сервертэй холбогдоход алдаа гарлаа',
                "Error",
                5000
            );
        }
    }
    useEffect(() => {
        fetchTags()
    }, []);
    const tagRender = props => {
        const { label, closable, onClose } = props;
        const onPreventMouseDown = event => {
            event.preventDefault();
            event.stopPropagation();
        };
        return (
            <Tag
                color={colorByValue.get(label) ?? "#d9d9d9"}
                onMouseDown={onPreventMouseDown}
                closable={closable}
                onClose={onClose}
                style={{ marginInlineEnd: 4 }}
            >
                {label}
            </Tag>
        );
    };

    const assignTag = async (tagId, storeName) => {
        try {
            const { data: result } = await axios.post(`${configFile.PROD_SERVER_URL}/store/assignTag`, {
                storeName,
                tagId
            })
            console.log(result)
        } catch (err) {
            NotificationManager.error(
                err?.response?.data?.errorMessage || 'Сервертэй холбогдоход алдаа гарлаа',
                "Error",
                5000
            );
            console.log(err)
        }
    }
    const unassignTag = async (tagId, storeName) => {
        try {
            const { data: result } = await axios.post(`${configFile.PROD_SERVER_URL}/store/unassignTag`,
                {
                    storeName,
                    tagId
                }
            )
            console.log(result)
        } catch (err) {
            NotificationManager.error(
                err?.response?.data?.errorMessage || 'Сервертэй холбогдоход алдаа гарлаа',
                "Error",
                5000
            );
            console.log(err)
        }
    }
    return (
        <Form.Item
            label='Tags'
            name={name}
            rules={[{ required: required, message: `${props.label} оруулна уу !` }]}
        >
            <Select
                mode='tags'
                showSearch
                tagRender={tagRender}
                placeholder='Tag сонгоно уу'
                onSelect={(val) => assignTag(val, storeName)}
                onDeselect={(val) => unassignTag(val, storeName)}
                defaultValue={props.value?.map(single => { return { label: single.slug, value: single.id } })}
                options={tags.map(single => { return { label: single.slug, value: single.id } })}
            />
        </Form.Item>
    );
};

export default SelectStoreTags;
